// Den echten Grund aus einem Edge-Function-Fehler holen.
//
// `supabase.functions.invoke()` setzt bei jedem Status ausserhalb von 2xx einen
// `FunctionsHttpError`, dessen `message` immer derselbe Satz ist:
// „Edge Function returned a non-2xx status code". Die eigentliche Auskunft der
// Function steckt im Antwortkörper und liegt unangetastet in `error.context`.
//
// Das ist eine lautlose Falle: Die Function antwortet sauber mit
// `{ error: "Ein Admin-Konto lässt sich nicht übernehmen." }` und 403, und im
// Browser steht trotzdem nur der nichtssagende Satz. Wer den Fehler dann sucht,
// sucht an der falschen Stelle.
//
// Beispiel:
//   if (response.error) {
//     throw new Error(await fehlertextAusEdgeFunction(response.error));
//   }

/**
 * Liefert den Text aus dem Antwortkörper, sonst die allgemeine Meldung.
 *
 * Erkennt `{ error: "…" }` und `{ message: "…" }`; beides kommt in diesem
 * Projekt vor.
 */
export async function fehlertextAusEdgeFunction(fehler: unknown): Promise<string> {
  const kontext = (fehler as { context?: unknown } | null)?.context;

  if (kontext instanceof Response) {
    try {
      // `clone()`, damit ein späterer Leser den Körper noch bekommt.
      const koerper: unknown = await kontext.clone().json();
      const text =
        (koerper as { error?: unknown })?.error ??
        (koerper as { message?: unknown })?.message;
      if (typeof text === "string" && text.trim()) return text.trim();
    } catch {
      // Kein JSON oder Körper schon gelesen – dann bleibt die allgemeine Meldung.
    }
  }

  const nachricht = (fehler as { message?: unknown } | null)?.message;
  return typeof nachricht === "string" && nachricht.trim()
    ? nachricht.trim()
    : "Unbekannter Fehler";
}
